export const CHECK_REGION_MATCH_BEFORE_SELECTING_RESTAURANT = true;
